import { render, staticRenderFns } from "./MailingsListSelect.vue?vue&type=template&id=23e8d254&scoped=true&"
import script from "./MailingsListSelect.vue?vue&type=script&lang=ts&"
export * from "./MailingsListSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8d254",
  null
  
)

export default component.exports